import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";

import useStyles from "./styles/DesktopViewStyles";
import { TEAM_PAGE } from "../../../../constants";
import { fundRaiserPageAction } from "../../../../store/actions";
import { UpdatesAndCommentsSkeleton } from "../../../../components/skeletons";
import { CommentBox, ContentWithHeading, ImageViewer, LongText, MixPanelTrackedLink, Span } from "../../../../components";

export function DesktopView() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    const comments = useSelector(state => state.fundraiser_page.fundraiser_page_updates)
    const user = useSelector(state => state.authentication.user);

    const [state, setState] = useState({
        offset: 0,
        limit: 6
    });
    const [loadingComments, setLoadingComments] = useState(false);
    const [totalComments, setTotalComments] = useState(0);
    const [commentAndUpdates, setCommentsAndUpdates] = useState([]);

    const isOwner = pageDetails.user_id == user.id;
    const ownerName = pageDetails.first_name + " " + pageDetails.last_name;

    const updateOffset = () => {
        setState({
            ...state,
            offset: state.offset + state.limit
        });
    }

    const loadMoreComments = async () => {
        setLoadingComments(true);
        await dispatch(fundRaiserPageAction.getFundRaiserPageUpdates(pageDetails.id, 2, state.offset, state.limit));
        setLoadingComments(false);
    }

    useEffect(() => {
        dispatch(fundRaiserPageAction.getFundRaiserPageUpdates(pageDetails.id, 1, state.offset, state.limit));
    }, [pageDetails]);

    useEffect(() => {
        if (state.offset > 0) {
            loadMoreComments()
        }
    }, [state.offset]);

    useEffect(() => {
        if (comments) {
            setTotalComments(comments.count);
            setCommentsAndUpdates(comments.updates);
        }
    }, [comments, comments.updates])

    return totalComments || isOwner ? <ContentWithHeading _className={classes.updatesAndCommentSection} heading={`Updates and Comments (${comments.count || 0})`}>
        {
            isOwner && <CommentBox />
        }
        <div>
            {
                commentAndUpdates ?
                    <ul className="timeline">
                        {commentAndUpdates.map((item, key) =>
                            <li className="updates">
                                <div className="camp-update-info">
                                    <Span className="camp-update-date">{item.date_created_at}</Span>
                                    <Span className="camp-update-by">by <Span className="fuser-name">{ownerName}</Span>, {(pageDetails && pageDetails.page_type === TEAM_PAGE ? 'Team' : '')} Organizer</Span>
                                </div>
                                <LongText className="update-data" content={item.description} limit={250} />
                                <div className="update-data img-gallery">
                                    {item.images && <ImageViewer images={item.images} />}
                                </div>
                            </li>
                        )}
                    </ul> :
                    <UpdatesAndCommentsSkeleton />
            }
            <div className={classes.buttonContainer}>
                {commentAndUpdates &&
                    commentAndUpdates.length < totalComments &&
                    <MixPanelTrackedLink
                        type="button"
                        label="Show Older"
                        context="Show older comments"
                        variant="outlined"
                        onClick={updateOffset}
                    >
                        {loadingComments ? <CircularProgress size={25} /> : 'Show Older'}
                    </MixPanelTrackedLink>}
            </div>
        </div>
    </ContentWithHeading> : null
}